import { render, staticRenderFns } from "./potential.vue?vue&type=template&id=764e0075&scoped=true"
import script from "./potential.vue?vue&type=script&lang=js"
export * from "./potential.vue?vue&type=script&lang=js"
import style0 from "./potential.vue?vue&type=style&index=0&id=764e0075&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764e0075",
  null
  
)

export default component.exports